export enum ETransactionType {
    PendingChargeWallet=0,
    BankDeposit = 1,
    FeeSiteDeposit = 2,
    IncomeDoctorDeposit = 3,
    DirectPayment = 4,
    WithDrawFromWallet = 5,
    CancelVisit=6,
    AdminCashOut=7,
    TransactionLogError=8
}